import { decodeToken, IRefreshTokenData, ITokenData } from 'utils/service/token';
import { StateCreator } from 'zustand';

type TwoFactorMethod = 'otp' | '2fa';

interface IAuthState {
  token: string | null;
  tokenData: ITokenData | null;
  refreshToken: string | null;
  refreshTokenData: IRefreshTokenData | null;
  twoFactorTokenExpiresAt: number | null;
  serviceTokenExpiresAt: number | null;
  twoFactorMethod: TwoFactorMethod | null;
}

interface IAuthActions {
  setToken: (token: IAuthState['token']) => void;
  setRefreshToken: (refreshToken: IAuthState['refreshToken']) => void;
  setTwoFactorTokenExpiresAt: (
    twoFactorTokenExpiresAt: IAuthState['twoFactorTokenExpiresAt'],
  ) => void;
  setServiceTokenExpiresAt: (serviceTokenExpiresAt: IAuthState['serviceTokenExpiresAt']) => void;
  setTwoFactorMethod: (method: TwoFactorMethod | null) => void;
  clearTokens: () => void;
}

export interface IAuthStore extends IAuthState, IAuthActions {}

export const createAuthSlice: StateCreator<IAuthStore> = (set, get) => ({
  token: null,
  tokenData: null,
  refreshToken: null,
  refreshTokenData: null,
  twoFactorTokenExpiresAt: null,
  serviceTokenExpiresAt: null,
  twoFactorMethod: null,
  setToken: (token) => {
    if (!token?.length) {
      return set(() => ({
        token: null,
        tokenData: null,
      }));
    }
    const tokenData = decodeToken<ITokenData>(token);

    set({
      token: token,
      tokenData: tokenData,
    });
  },
  setRefreshToken: (token) => {
    if (!token?.length) {
      return set(() => ({
        refreshToken: null,
        refreshTokenData: null,
      }));
    }
    const tokenData = decodeToken<IRefreshTokenData>(token);

    set({
      refreshToken: token,
      refreshTokenData: tokenData,
    });
  },
  setTwoFactorTokenExpiresAt: (expires: number | null) => {
    const twoFactorTokenExpiresAt = expires ? Date.now() + expires : 0;
    set({
      twoFactorTokenExpiresAt,
    });
  },
  setServiceTokenExpiresAt: (expires: number | null) => {
    const serviceTokenExpiresAt = expires ? Date.now() + expires : 0;
    set({
      serviceTokenExpiresAt,
    });
  },
  setTwoFactorMethod: (method) => {
    set({ twoFactorMethod: method });
  },
  clearTokens: () => {
    set({
      token: null,
      tokenData: null,
      refreshTokenData: null,
      refreshToken: null,
      twoFactorTokenExpiresAt: null,
      serviceTokenExpiresAt: null,
    });
  },
});
